export default "__VITE_PUBLIC_ASSET__52705479__"